import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { AppStore, FooterMenuColumnType, IFooterMenuColumn } from '@app-store';
import { MenuItemLinkType } from '@utils/enum/menu-item-link-type.enum';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, MatIconModule]
})
export class FooterComponent implements OnInit {
  private readonly appStore = inject(AppStore);

  readonly columns = computed(() => this.appStore.footerMenuColumns());
  readonly isLoading = computed(() => this.appStore.footerMenuLoading());
  readonly error = computed(() => this.appStore.footerMenuError());

  FooterMenuColumnType: typeof FooterMenuColumnType = FooterMenuColumnType;
  MenuItemLinkType: typeof MenuItemLinkType = MenuItemLinkType;

  ngOnInit(): void {
    this.appStore.fetchFooterMenuColumns();
  }

  trackByColumn(index: number, column: IFooterMenuColumn): string {
    return column.label || index.toString();
  }

  trackBySection(index: number, section: any): string {
    return section.label || index.toString();
  }

  trackByMenuItem(index: number, item: any): string {
    return item.label || index.toString();
  }
}
